import { PageHeader, Button } from "@evertrue/et-components";
import useJourneyTimeoutsForm from "../../../hooks/journey-timeouts/use-journey-timeouts-form";
import DatePickerDropdown from "components/calendar/date-picker-dropdown";
import ConfirmModal from "../../modals/confirm-pause-modal";
import FormField from "components/forms/form-field";
import { trackJourneysAction } from "apps/journeys/utils/helpers";
import useJourneyTimeoutsApi from "apps/journeys/hooks/journey-timeouts/use-journey-timeouts-api";

const PauseJourneyForm = () => {
  const { inProgressJourneyTimeout, futureJourneyTimeout, handleCreate, handleUpdate, handleResume, handleCancel } =
    useJourneyTimeoutsApi();

  const {
    startMessage,
    selectedStartDate,
    endMessage,
    selectedEndDate,
    disableSave,
    modalTitle,
    modalBody,
    modalAction,
    isModalOpen,
    closeModal,
    handleEndDateClick,
    handleStartDateClick,
    handleCancelClick,
    handleResumeClick,
  } = useJourneyTimeoutsForm(inProgressJourneyTimeout, futureJourneyTimeout);

  const handleCreateClick = () => {
    trackJourneysAction("create_cadence_pause");
    handleCreate(selectedStartDate, selectedEndDate);
  };

  const handleUpdateClick = () => {
    handleUpdate(selectedStartDate, selectedEndDate);
  };

  const resumeAction = () => {
    trackJourneysAction("end_cadence_pause");
    handleResume();
    closeModal();
  };

  const cancelAction = () => {
    handleCancel();
    closeModal();
  };

  return (
    <>
      <PageHeader title="Pause Cadences" className="pause-journey-header" />
      <p className="pause-journey-warning">
        Pausing cadences will freeze all your cadences until you return. You can resume your cadences at any time.
      </p>
      <FormField label="Start Date" inlineLabel={false} className="pause-journey-date-label">
        <div className="pause-journey-date-container" data-testid="date-picker-dropdown">
          <DatePickerDropdown
            date={selectedStartDate}
            onDayClick={handleStartDateClick}
            triggerClassName={"pause-journey-date-picker"}
            chevronClassName={"date-picker-chevron"}
            allowClear={true}
          />
          <p className="pause-modal--date-text">{startMessage}</p>
        </div>
      </FormField>
      <FormField label="Return Date" inlineLabel={false} className="pause-journey-date-label">
        <div className="pause-journey-date-container" data-testid="date-picker-dropdown">
          <DatePickerDropdown
            date={selectedEndDate}
            onDayClick={handleEndDateClick}
            triggerClassName={"pause-journey-date-picker"}
            chevronClassName={"date-picker-chevron"}
            allowClear={true}
          />
          <p className="pause-modal--date-text">{endMessage}</p>
        </div>
      </FormField>
      {!!inProgressJourneyTimeout || !!futureJourneyTimeout ? (
        <div className="pause-journey-buttons">
          {!!inProgressJourneyTimeout && (
            <Button type="secondary" onClick={handleResumeClick}>
              Resume All Cadences
            </Button>
          )}
          {!!futureJourneyTimeout && (
            <Button type="secondary" onClick={handleCancelClick}>
              Cancel Pause
            </Button>
          )}
          <Button onClick={handleUpdateClick} disabled={disableSave}>
            Save
          </Button>
        </div>
      ) : (
        <div className="pause-journey-buttons">
          <Button onClick={handleCreateClick} disabled={!selectedStartDate || !selectedEndDate}>
            Save
          </Button>
        </div>
      )}
      <ConfirmModal
        title={modalTitle}
        body={modalBody}
        handleAction={modalAction === "Resume" ? resumeAction : cancelAction}
        actionName={modalAction}
        isOpen={isModalOpen}
        onClose={closeModal}
      />
    </>
  );
};

export default PauseJourneyForm;
